<template>
  <div class="banner-wrapper gap-2 relative">
    <div
      class="banner flex gap-x-12 gap relative items-center h-fit md:h-auto"
      :class="
        showGiftbox
          ? 'justify-between md:items-center py-6 md:py-12 max-md:flex-wrap-reverse'
          : 'py-4 min-h-[420px] sm:min-h-[420px] max-sm:flex-wrap-reverse'
      "
      :style="{
        backgroundColor: (!bgImage ? bgColor : null) || 'transparent',
      }"
    >
      <div
        v-if="bgImage || bgColor"
        class="banner_heading_bg -z-[-1] absolute w-full h-full left-0 pointer-events-none"
        :style="{
          backgroundColor: (!bgImage ? bgColor : null) || 'transparent',
        }"
      >
        <NuxtImg
          v-if="bgImage"
          :src="bgImage"
          class="banner__image rounded w-full h-full object-cover hidden md:block"
          alt="Giftcard"
          :height="'auto'"
          aspect-ratio="auto"
          sizes="xs:100vw sm:100vw md:100vw lg:100vw xl:100vw xxl:100vw"
          preload
        />
        <NuxtImg
          v-if="bgImageMobile"
          :src="bgImageMobile"
          class="banner__image rounded w-full h-full object-cover md:hidden"
          alt="Giftcard"
          :height="'auto'"
          aspect-ratio="auto"
          sizes="xs:100vw sm:100vw md:100vw lg:100vw xl:100vw xxl:100vw"
          preload
        />
      </div>
      <div
        v-if="text || description"
        class="banner__container flex w-full md:p-0 [&.padded]:md:px-8 flex-col justify-center overflow-hidden break-words"
        :class="[
          showGiftbox
            ? 'md:max-w-[572px] md:min-h-[360px]'
            : 'md:max-w-[450px] py-4 md:py-7',
          { padded: padded },
        ]"
      >
        <div class="banner__heading" :class="showGiftbox && 'max-md:mt-8'">
          <Heading
            :level="1"
            :title="text"
            h-class="text-2xl leading-tight md:text-3xl font-semibold"
            class="kft-heading--left"
            :test-id="testId"
          />
          <p v-if="description" class="banner__description mt-1">
            {{ description }}
          </p>
        </div>

        <GiftcardBuyBox v-if="showGiftbox" class="mt-3 w-full lg:pr-14" />

        <slot name="button">
          <Button
            v-show="!hideButton"
            class="w-100 mt-6"
            :link="callToActionLink"
            @click="action"
          >
            {{ actionLabel }}
          </Button>
        </slot>
      </div>
      <slot v-if="$slots.default"></slot>
      <div
        v-else
        v-show="featuredMedia.slice(0, 1).length > 0"
        class="banner__side-gallery max-sm:overflow-hidden sm:empty:hidden w-full relative"
        :class="
          showGiftbox
            ? 'banner__side-gallery--flat max-md:overflow-hidden h-[220px] sm:h-[380px] md:h-[360px] md:w-[46%] md:shrink-0'
            : 'h-[240px] h-max sm:h-[450px] min-w-[60%] before:rounded-xl before:top-0 before:left-0 sm:before:top-5 sm:before:-left-5'
        "
      >
        <div
          v-for="img in featuredMedia.slice(0, 1) || []"
          :key="img.id"
          class="side-image-container relative shrink-0 w-full h-full"
        >
          <component :is="img.url ? 'a' : 'div'" :href="img.url" class="h-full">
            <NuxtImg
              :src="String(img?.src)"
              :alt="img.alt"
              class="banner__image h-full w-full rounded-lg sm:rounded-2xl object-cover"
              :height="'auto'"
              aspect-ratio="auto"
              sizes="xs:100vw sm:100vw md:100vw lg:100vw xl:100vw xxl:100vw"
              preload
            />
          </component>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  props: {
    height: {
      type: Number,
      default: 240,
    },
    bgColor: {
      type: String,
      default: null,
    },
    padded: {
      type: Boolean,
      default: false,
    },
    bgImage: {
      type: String,
      default: null,
    },
    bgImageMobile: {
      type: String,
      default: null,
    },
    hideButton: {
      type: Boolean,
      default: false,
    },
    action: {
      type: Function,
      default: () => () => null,
    },
    callToActionLink: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    testId: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    featuredMedia: {
      type: Array,
      default: () => [],
    },
    actionLabel: {
      type: String,
      default: null,
    },
    showGiftbox: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="postcss" scoped>
.banner-wrapper .banner__side-gallery:before {
  position: absolute;
  @apply md:bg-lime-200;
  display: block;
  content: none;
  width: 100%;
  height: 100%;
}
.banner-wrapper .banner__side-gallery .banner-gallery-image-text {
  text-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
}
</style>
